import store from "../services/reports.stores";
import notification from "../services/notification";

export default {
    namespaced: true,

    state: {
        loading: false,
        error: false,
        errors: null,
        list: [],
        filters: null,
        yearFilters: [],
        import: false,
        importfile: null,
        importBase: null,
        uploading: false,
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        param: {
            // param: {
            //     keyword: null,
            //     filter: null,
            //     year: new Date().getFullYear().toString()
            // },
            // limit: (new Date().getMonth() + 1).toString(),
            page: 1
        },
        store_modal: {
            new: {
                status: false
            },
            edit: {
                status: false,
                uuid: null
            },
            delete: {
                status: false,
                uuid: null,
                store_name: ""
            }
        },
        membership_id: null,
        owner: null
    },

    mutations: {
        loading(state, value) {
            state.loading = value;
        },
        errors(state, errors) {
            state.error = true;
            state.errors = errors.errors;
        },
        clearErrors(state) {
            state.error = false; 
            state.errors = null;
        },
        setList(state, list) {
            state.list = list;
        },
        setPage(state, page) {
            state.param.page = page;
        },
        setModal(state, modal) {
            switch (modal.type) {
                case "new":
                    state.store_modal[modal.type].status = modal.status;
                    break;
                case "edit":
                    state.store_modal[modal.type].status = modal.status;
                    state.store_modal[modal.type].uuid = modal.uuid;
                    break;
                case "delete":
                    state.store_modal[modal.type].status = modal.status;
                    state.store_modal[modal.type].uuid = modal.uuid;
                    state.store_modal[modal.type].store_name = modal.store_name;
                    break;
            }
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },
        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage = state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount * state.pagination.prevPage + 1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem + state.pagination.totalPerPage - 1
                    : 0;
        },
        setMembershipID(state, membership_id) {
            state.membership_id = membership_id;
        },
        setCustomerOwner(state, name) {
            state.owner = name.firstname + " " + name.lastname;
        }
    },

    actions: {
        getList: async ({ commit, state }, param) => {
            commit("loading", true);
            try {
                let response = await store.getList({
                    membership_id: param.membership_id,
                    page: param.page
                });

                if (param.page == 1) {
                    commit("setInitialPageCount", response.list);
                }

                commit("setList", response.list);
                commit("setPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        getCustomerMembershipID: async ({ commit }, param) => {
            commit("loading", false);
            try {
                let response = await store.getCustomerMembershipID(param);

                response.list.forEach(function(customer) {
                    if (customer.uuid === param.uuid) {
                        commit("setMembershipID", customer.membership_id);
                        commit("setCustomerOwner", {
                            firstname: customer.firstname,
                            lastname: customer.lastname
                        });
                    }
                });
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        create: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await store.create(param);
                notification.success(response.message);
                commit("loading", false);
                commit("clearErrors");
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, unable to create store.");
            }
        },

        update: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await store.update(param);
                notification.success(response.message);
                commit("loading", false);
                commit("clearErrors");
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, unable to update store.")
            }
        },

        delete: async ({ commit }, uuid) => {
            commit("loading", true);
            try {
                let response = await store.delete(uuid);
                notification.success("Store successfully deleted.");
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, unable to delete store.");
            }
        }
    }
}